export default __webpack_public_path__ + "static/4-67b21b7d1083f8adcc5821cdf4bc2728.png";